import { Link } from "@components/Catalyst/link";
import PageSection from "@components/PageSection";
import { ITechDataFields, ProcessNonColorTechData, ProcessProductTechData } from "@services/TechData";
import { FlexBox, Text } from "@styles";
import { BrandCode } from "@typed/common";
import React from "react";

const TechData = ({ product, brand }: { product: Queries.ProductTechInfoFragment; brand: string }) => {
  let values: ITechDataFields[] = [];

  if (product.products_colors) values = ProcessProductTechData(product, brand as BrandCode);

  if (product.products_noncolor) values = ProcessNonColorTechData(product);

  if (!values || !values.length) return null;

  return (
    <PageSection sectionName="Technical Detail">
      <table>
        <tbody>
          {values.map(({ name, value, icon, iconWidth, showValueText }) => (
            <tr key={name}>
              <td width={175}>
                <Text>{name}</Text>
              </td>
              <td>
                <FlexBox alignItems="center">
                  {icon && (
                    <FlexBox height={1.25}>
                      <img src={icon} alt={value} width={iconWidth} />{" "}
                    </FlexBox>
                  )}
                  {(!icon || showValueText) && value}
                </FlexBox>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Link className="mt-2 text-sm underline" href="/technical-specifications-explained">
        Explanation of technical specifications
      </Link>
    </PageSection>
  );
};

export default TechData;
